import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import 'babel-polyfill'

import MetaInfo from 'vue-meta-info'
Vue.use(MetaInfo)

import '@/public/css/reset.css' // 初始化css
import '@/public/css/common.css' // 公共样式
import '@/public/css/border.css' // 公共样式
import '@/public/iconfont/iconfont.css' // iconfont 
import {
  message
} from '@/util/resetMessage';
Vue.prototype.$nodata = require('@/public/img/nodata.png')
Vue.prototype.$no = require('@/public/img/no.jpg')
Vue.prototype.$shili = require('@/public/img/shili.png')


// 本地示例图片
Vue.prototype.$shili_brandAddNew = require('@/public/img/shili_brandAddNew.png')
Vue.prototype.$shili_brandUpload = require('@/public/img/shili_brandUpload.png')
Vue.prototype.$shili_brandUploads = require('@/public/img/shili_brandUploads.png')
Vue.prototype.$shili_infoEdit = require('@/public/img/shili_infoEdit.png')
Vue.prototype.$shili_authenticate1 = require('@/public/img/shili_authenticate1.png')
Vue.prototype.$shili_authenticate2 = require('@/public/img/shili_authenticate2.png')
Vue.prototype.$shili_cauthenticate1 = require('@/public/img/shili_cauthenticate1.png')
Vue.prototype.$shili_cauthenticate2 = require('@/public/img/shili_cauthenticate2.png')
// 文本编辑器
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
Vue.use(VueQuillEditor)


import axios from 'axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)


import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
Vue.prototype.$message = message;

import postData from "./util/util";
Vue.prototype.post = postData

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
  // mounted () {
  //   document.dispatchEvent(new Event('render-event'))
  // }
}).$mount('#app')
